<template>
	<div id="app" class="layout-1 layout-without-sidenav layout-footer-fixed">
    <template v-if="isVerify || isBuyUrl || isLearnerSignUp || isInstitutionSignin || isUserSetup || isLearnMore">
      <verify ref="verify" v-if="isVerify"></verify>
      <buy-url ref="buyUrl" v-if="isBuyUrl"></buy-url>
      <learn-more ref="learnMore" v-if="isLearnMore"></learn-more>
      <user-setup ref="userSetup" v-if="isUserSetup"></user-setup>
      <learner-signup ref="learnerSignup" v-if="isLearnerSignUp"></learner-signup>
      <institution-signin ref="institutionSignin" v-if="isInstitutionSignin"></institution-signin>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
    <notifications group="notify" position="top center" />
    <smhandle></smhandle>
  </div>
</template>

<script>
//import '../assets/theme/default/css/defaultTheme.min.css'
import '../assets/theme/default/sass/global.scss'
import { UserSetup } from './dashboard/components'
import Smhandle from './misc/components/./Smhandle'
import { Verify, LearnerSignup, InstitutionSignin, BuyUrl, LearnMore } from './login/components'
import { Plugins } from '@capacitor/core'
const { App } = Plugins

export default {
  name: 'app',
  components: {
    Verify,
    BuyUrl,
    LearnMore,
    UserSetup,
    LearnerSignup,
    InstitutionSignin,
    Smhandle
  },
  data: () => {
    return {
      isBuyUrl: (window.location.href.indexOf('buy') !== -1),
      isVerify: (window.location.href.indexOf('verify') !== -1),
      isLearnMore: (window.location.href.indexOf('learnMore') !== -1),
      isUserSetup: (window.location.href.indexOf('/user/setup') !== -1),
      isLearnerSignUp: (window.location.href.indexOf('learnerSignup') !== -1),
      isInstitutionSignin: (window.location.href.indexOf('institutionSignin') !== -1)
    }
  },
  mounted () {
    this.handleBackButton()
  },
  methods: {
    handleBackButton () {
      App.addListener('backButton', () => {
        if (this.$route.name === 'login') {
          App.exitApp()
        } else if (this.$route.name === 'dashboard') {
          return this.$router.replace('/')
        } else {
          window.history.back()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/App.vue